import { Box, FormLabel, InputAdornment, TextField } from "@mui/material";
import themeColorsDesingSystem from "assets/theme/ds-colors";

export default function InputText({
  label,
  value,
  onChange,
  placeholder,
  required,
  disabled,
  readOnly,
  rows = null,
  multiline = false,
  error = false,
  errorMessage = "",
  startAdornment = null,
  endAdornment = null,
  type = "text",
  white = false,
  props,
}) {
  return (
    <Box>
      <FormLabel
        sx={{
          color: white
            ? themeColorsDesingSystem.white.main
            : themeColorsDesingSystem.text.primary,
          fontSize: ".875rem",
          fontWeight: "600",
          lineHeight: 1.5,
          mb: 0,
          fontFamily: "Open Sans,sans-serif",
        }}
      >
        {label}
        {required ? " *" : ""}
      </FormLabel>

      <TextField
        variant="outlined"
        required={required}
        disabled={disabled}
        readOnly={readOnly}
        placeholder={placeholder}
        error={error}
        helperText={errorMessage}
        multiline={multiline}
        rows={rows}
        InputProps={{
          startAdornment: startAdornment && (
            <InputAdornment position="start" sx={{ p: 0 }}>
              {startAdornment}
            </InputAdornment>
          ),
          endAdornment: endAdornment && (
            <InputAdornment position="end" sx={{ p: 0 }}>
              {endAdornment}
            </InputAdornment>
          ),
        }}
        fullWidth
        value={value}
        onChange={onChange}
        type={type}
        sx={{
          "& .MuiOutlinedInput-root": {
            backgroundColor: white
              ? themeColorsDesingSystem.white.main
              : "transparent",
            "&.Mui-focused fieldset": {
              borderColor: themeColorsDesingSystem.primary.main,
            },
          },
          "& .MuiOutlinedInput-root.Mui-disabled": {
            backgroundColor: themeColorsDesingSystem.stone.light,
            cursor: "default",
            color: themeColorsDesingSystem.text.primary,
          },
          "& .MuiInputBase-input": {
            fontFamily: "Open Sans,sans-serif",
            color: themeColorsDesingSystem.text.primary,
            fontSize: ".875rem",
            padding: "9px 4px 9px 12px!important",
          },
          "& .MuiInputBase-multiline": {
            padding: "0 !important",
          },
        }}
        {...props}
      />
    </Box>
  );
}
